<template>
  <div class="about-page">
    <div class="ss-breadcrumb">
      <div class="container-hts">
        <ul class="margin-0 p-0">
          <li>
            <router-link :to="{name: 'home'}">Trang chủ</router-link>
          </li>
          <li>
            <router-link :to="{name: 'page-about'}" class="active">Giới thiệu</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="about-content primary-color-txt font-sanpro-light line-height-1-5">
      <div class="container-hts">
        <p>
          Trong bối cảnh cách mạng 4.0 tác động mạnh mẽ tới nhiều khía cạnh của cuộc
          sống, trong đó có lĩnh vực giáo dục, Nhà xuất bản Giáo dục Việt Nam đã phát triển
          nền tảng sách điện tử Hành trang số song hành với các bộ Sách giáo khoa mới (lớp
          1, lớp 2, lớp 6) và các bộ Sách giáo khoa hiện hành.
        </p>
        <p>Nền tảng sách điện tử Hành trang số chính thức ra mắt giáo viên và học sinh cả nước với ba tính năng chính:</p>
        <p>
          <b class="color-dark font-sanpro-semibold">Sách điện tử:</b> 
          Cung cấp giao diện thân thiện, trực quan, tôn trọng trải nghiệm đọc
          sách thực tế; đồng thời đính kèm các học liệu điện tử sinh động bổ trợ cho nội dung
          bài học và bài tập tương tác, đối chiếu trực tiếp.
        </p>
        <p>
          <b class="color-dark font-sanpro-semibold">Luyện tập:</b> 
          Cung cấp hệ thống bài tập trích xuất từ sách giáo khoa, sách bổ trợ, kết
          hợp với kho Tự kiểm tra - đánh giá, bài tập chuyên đề, đề thi; đồng thời tích hợp
          chức năng kiểm tra đúng - sai, hướng dẫn và lời giải chi tiết để hỗ trợ học sinh tự
          luyện tập, thực hành và giúp thầy/cô có nguồn tài liệu tham khảo, giảng dạy.
        </p>
        <p>
          <b class="color-dark font-sanpro-semibold">Thư viện:</b> 
          Cung cấp hệ thống bài tập trích xuất từ sách giáo khoa, sách bổ trợ, kết
          hợp với kho Tự kiểm tra - đánh giá, bài tập chuyên đề, đề thi; đồng thời tích hợp
          chức năng kiểm tra đúng - sai, hướng dẫn và lời giải chi tiết để hỗ trợ học sinh tự
          luyện tập, thực hành và giúp thầy/cô có nguồn tài liệu tham khảo, giảng dạy.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'About',
    data () {
        return {

        }
    }
  }
</script>

<style lang="scss" scoped>
  .about-content {
    padding: 45px 0 25px;
  }
</style>